"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAuthWheel = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useGetAuthWheel = function () {
    var currency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GET_WHEEL,
        revalidateOnMount: true,
        payload: {
            currency: currency,
            lang: lang,
        },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, isValidating = _a.isValidating;
    return (0, react_1.useMemo)(function () {
        var _a, _b;
        return ({
            data: ((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.wheel) === null || _b === void 0 ? void 0 : _b.get) || [],
            isLoading: isLoading,
            isValidating: isValidating,
            error: error,
        });
    }, [data, isLoading, isValidating, error]);
};
exports.useGetAuthWheel = useGetAuthWheel;
